import React, { useRef, useMemo } from "react";
import { TrapStatusData } from "../../types";
import { useListTrapSitesQuery } from "../../actions/trapsiteInQuery";
import "./index.css";
import { useDeviceUuids } from "../../hooks/useAppAlerts";
import TrapStatus from "./TrapStatus";

const Index: React.FC = () => {
  const {
    deviceUuids,
    devices,
    isLoadingDevices: isDevicesLoading,
  } = useDeviceUuids();
  const deviceUuidSet = useMemo(() => new Set(deviceUuids), [deviceUuids]);

  const listContainerRef = useRef<HTMLDivElement>(null);

  const { data: trapSitesData, isLoading: isTrapSiteLoading } =
    useListTrapSitesQuery();

  const trapStatusData = useMemo(() => {
    const result: TrapStatusData[] = devices
      ?.map((device) => {
        // this is a filter to make sure we only show devices that are in the current location
        if (!deviceUuidSet.has(device?.uuid || "")) {
          return null;
        }
        const trapsite =
          trapSitesData?.items?.find((t) => {
            return t._id === device.trap_id;
          }) || {};
        return {
          _id: device.uuid,
          name: device?.display_name || device?.uuid || "",
          trapsite_name: trapsite.display_name || "Unknown Location",
          gps:
            trapsite?.gps?.lat && trapsite?.gps?.lon
              ? `${trapsite.gps.lat.toFixed(4)}, ${trapsite.gps.lon.toFixed(4)}`
              : "Unknown GPS",
          status: device?.status || "offline",
          status_updated_at: device?.status_updated_at || new Date(),
        };
      })
      // filter out nulls
      .filter((item) => item !== null)
      // Sort by trap_site name then by device name with unknowns at the end
      .sort((a, b) =>
        a?.trapsite_name === "Unknown Location" &&
        b?.trapsite_name !== "Unknown Location"
          ? 1
          : b?.trapsite_name === "Unknown Location" &&
              a?.trapsite_name !== "Unknown Location"
            ? -1
            : (a?.trapsite_name || "").localeCompare(b?.trapsite_name || "") ||
              (a?.name || "").localeCompare(b?.name || ""),
      ) as TrapStatusData[];

    return result;
  }, [devices, trapSitesData, deviceUuidSet]);

  const handleClickDialog = (id: string) => {
    // TODO: Handle click on alert dialog
  };

  return (
    <TrapStatus
      loading={isTrapSiteLoading || isDevicesLoading}
      listContainerRef={listContainerRef}
      trapStatusData={trapStatusData}
      handleClickDialog={handleClickDialog}
    />
  );
};

export default Index;
